module.exports = __webpack_public_path__ + "static/media/lessonSVG.79894f8b.svg";